import axios from 'axios';
import { baseRequestHandler } from '../baseRequestHandler';
import { getHeaders } from '../helpers';

const requestGetCarInsuranceConfig = async ({
  proxyPath,
  fingerprint,
  access_token,
  flow,
  axiosInstance = axios,
}) => {
  const url = `${proxyPath}/custom-actions/get-car-insurance-config/execute`;
  const headers = getHeaders(fingerprint ?? null, access_token ?? null);
  const payload = { data: { flow: flow } };

  return axiosInstance.post(url, payload, { headers });
};

export const getCarInsuranceConfig = baseRequestHandler(
  requestGetCarInsuranceConfig
);
